import { render, staticRenderFns } from "./OrganizationActions.vue?vue&type=template&id=4ad25cf6&scoped=true&"
import script from "./OrganizationActions.vue?vue&type=script&lang=js&"
export * from "./OrganizationActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad25cf6",
  null
  
)

export default component.exports